import * as Inovx from '@shared';
import DiagnosticsConstants from './../constants/DiagnosticsConstants';
import DiagnosticsServices from './../services/DiagnosticsServices';

var SystemStore = Inovx.Shared.System.Store;
var SystemActions = Inovx.Shared.System.Actions;

function receiveInitialData(data: any) {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: DiagnosticsConstants.GET_DATA,
        data: data
    });
}

function receiveNextData(data: any) {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: DiagnosticsConstants.GET_NEXT_DATA,
        data: data
    });
}

function receiveInitialAuditData(data: any) {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: DiagnosticsConstants.GET_AUDIT_DATA,
        data: data
    });
}

function receiveNextAuditData(data: any) {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: DiagnosticsConstants.GET_NEXT_AUDIT_DATA,
        data: data
    });
}

var ajaxRequest: any = null;

var DiagnosticsActions = {
    DisplayDiagnosticInformation(diagnosticId: string, callback?: any, errorCallback?: IErrorCallback, ignoreDefaultError?: boolean) {

        if (!SystemStore.isActionInProgress(DiagnosticsConstants.DISPLAY_DIAGNOSTICS)) {
            SystemActions.beginAction(DiagnosticsConstants.DISPLAY_DIAGNOSTICS);

            if (ajaxRequest) {
                ajaxRequest.abort();
                ajaxRequest = null;
            }

            ajaxRequest = DiagnosticsServices.getDetails(diagnosticId, function (data) {
                ajaxRequest = null;

                if (callback) {

                    callback(data);
                }

                Inovx.Shared.Flux.AppDispatcher.dispatch({
                    actionType: DiagnosticsConstants.DISPLAY_DIAGNOSTICS,
                    diagnosticInformation:data
                });
                SystemActions.endAction(DiagnosticsConstants.DISPLAY_DIAGNOSTICS);
            }, function (error) {
                ajaxRequest = null;

                if (error.statusText !== 'abort') {
                    if (errorCallback) {
                        errorCallback(error);
                    }
                }
                SystemActions.endAction(DiagnosticsConstants.DISPLAY_DIAGNOSTICS);
            }, ignoreDefaultError);
        }
    },

    CloseDiagnosticInformation() {

        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: DiagnosticsConstants.CLOSE_DIAGNOSTICS
        });
    },
    GetData: function (request: LogRequestObject, callback?: any, errorCallback?: IErrorCallback, ignoreDefaultError?: boolean) {
        if (!SystemStore.isActionInProgress(DiagnosticsConstants.GET_DATA)) {
            SystemActions.beginAction(DiagnosticsConstants.GET_DATA);

            if (ajaxRequest) {
                ajaxRequest.abort();
                ajaxRequest = null;
            }

            ajaxRequest = DiagnosticsServices.getLogs(request, function (data) {
                ajaxRequest = null;

                if (callback) {
                    callback(data);
                }

                receiveInitialData(data);
                SystemActions.endAction(DiagnosticsConstants.GET_DATA);
            }, function (error) {
                ajaxRequest = null;

                if (error.statusText !== 'abort') {
                    if (errorCallback) {
                        errorCallback(error);
                    }
                }
                SystemActions.endAction(DiagnosticsConstants.GET_DATA);
            }, ignoreDefaultError);
        }
    },

    GetDiagnosticsData: function (request: LogRequestObject, callback?: any, errorCallback?: IErrorCallback, ignoreDefaultError?: boolean) {
        if (!SystemStore.isActionInProgress(DiagnosticsConstants.GET_DATA)) {
            SystemActions.beginAction(DiagnosticsConstants.GET_DATA);

            if (ajaxRequest) {
                ajaxRequest.abort();
                ajaxRequest = null;
            }

            ajaxRequest = DiagnosticsServices.getLogs(request, function (data) {
                ajaxRequest = null;

                if (callback) {
                    callback(data);
                }

                receiveInitialData(data);
                SystemActions.endAction(DiagnosticsConstants.GET_DATA);
            }, function (error) {
                ajaxRequest = null;

                if (error.statusText !== 'abort') {
                    if (errorCallback) {
                        errorCallback(error);
                    }
                }
                SystemActions.endAction(DiagnosticsConstants.GET_DATA);
            }, ignoreDefaultError);
        }
    },
    GetAuditData: function (request: LogRequestObject, callback?: any, errorCallback?: IErrorCallback, ignoreDefaultError?: boolean) {
        if (!SystemStore.isActionInProgress(DiagnosticsConstants.GET_AUDIT_DATA)) {
            SystemActions.beginAction(DiagnosticsConstants.GET_AUDIT_DATA);

            if (ajaxRequest) {
                ajaxRequest.abort();
                ajaxRequest = null;
            }

            ajaxRequest = DiagnosticsServices.getLogs(request, function (data) {
                ajaxRequest = null;

                if (callback) {
                    callback(data);
                }

                receiveInitialAuditData(data);
                SystemActions.endAction(DiagnosticsConstants.GET_AUDIT_DATA);
            }, function (error) {
                ajaxRequest = null;

                if (error.statusText !== 'abort') {
                    if (errorCallback) {
                        errorCallback(error);
                    }
                }
                SystemActions.endAction(DiagnosticsConstants.GET_AUDIT_DATA);
            }, ignoreDefaultError);
        }
    },
    ExportToCSV: function (request: LogRequestObject, progressCallback: (inProgress: boolean) => void, callback?: any, errorCallback?: IErrorCallback) {
        progressCallback(true);
        if (!SystemStore.isActionInProgress(DiagnosticsConstants.GET_CSV)) {
            SystemActions.beginAction(DiagnosticsConstants.GET_CSV);

            if (ajaxRequest) {
                ajaxRequest.abort();
                ajaxRequest = null;
                progressCallback(false);
            }

            ajaxRequest = DiagnosticsServices.getCSV(request, function (data) {
                ajaxRequest = null;
                if (callback) {
                    callback(data);
                }

                //receiveNextData(data);
                SystemActions.endAction(DiagnosticsConstants.GET_CSV);
                progressCallback(false);
            }, function (error) {
                ajaxRequest = null;

                if (error.statusText !== 'abort') {
                    if (errorCallback) {
                        errorCallback(error);
                    }
                }
                SystemActions.endAction(DiagnosticsConstants.GET_CSV);
                progressCallback(false);
            });
        }
    },
    GetNextData: function (request: LogRequestObject, callback?: any, errorCallback?: IErrorCallback) {
        if (!SystemStore.isActionInProgress(DiagnosticsConstants.GET_NEXT_DATA)) {
            SystemActions.beginAction(DiagnosticsConstants.GET_NEXT_DATA);

            if (ajaxRequest) {
                ajaxRequest.abort();
                ajaxRequest = null;
            }

            ajaxRequest = DiagnosticsServices.getLogs(request, function (data) {
                ajaxRequest = null;
                if (callback) {
                    callback(data);
                }

                receiveNextData(data);
                SystemActions.endAction(DiagnosticsConstants.GET_NEXT_DATA);
            }, function (error) {
                ajaxRequest = null;

                if (error.statusText !== 'abort') {
                    if (errorCallback) {
                        errorCallback(error);
                    }
                }
                SystemActions.endAction(DiagnosticsConstants.GET_NEXT_DATA);
            });
        }
    }
}

export default DiagnosticsActions;
